"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _dismissIcon = _interopRequireDefault(require("../Icon/dismissIcon"));

var _textInput = _interopRequireDefault(require("../TextInput/textInput"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Search =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Search, _React$Component);

  _createClass(Search, null, [{
    key: "defaultProps",
    get: function get() {
      return {
        onSearch: function onSearch() {},
        placeholder: '',
        triggerDelay: 300,
        debounceFn: _lodash.default
      };
    }
  }]);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, props));
    _this.onClear = _this.onClear.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.state = {
      value: props.value ? props.value : '',
      searchHandler: (0, _lodash.default)(props.onSearch, props.triggerDelay)
    };
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.value !== this.props.value) {
        this.onChange(this.props.value);
      }
    }
  }, {
    key: "onClear",
    value: function onClear(event) {
      this.state.searchHandler.cancel();
      this.props.onSearch('');
      this.setState({
        value: ''
      });
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      this.setState({
        value: value
      });
      this.state.searchHandler(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          autoFocus = _this$props.autoFocus,
          autoComplete = _this$props.autoComplete,
          tabIndex = _this$props.tabIndex,
          small = _this$props.small,
          large = _this$props.large,
          onKeyUp = _this$props.onKeyUp,
          error = _this$props.error,
          warning = _this$props.warning,
          props = _objectWithoutProperties(_this$props, ["id", "name", "placeholder", "disabled", "autoFocus", "autoComplete", "tabIndex", "small", "large", "onKeyUp", "error", "warning"]);

      var value = this.state.value;
      var showClear = value !== '';
      var classes = 'co-search';
      var modifiers = {
        small: small,
        large: large,
        error: error,
        warning: warning
      };
      return _react.default.createElement(_styler.default, {
        classNames: classes,
        modifiers: modifiers
      }, function (styles) {
        return _react.default.createElement("div", _extends({
          className: styles
        }, (0, _getNativeProps.default)(props)), _react.default.createElement(SearchInput, {
          id: id,
          name: name,
          placeholder: placeholder,
          value: value,
          disabled: disabled,
          autoFocus: autoFocus,
          autoComplete: autoComplete,
          onChange: _this2.onChange,
          tabIndex: tabIndex,
          onKeyUp: onKeyUp
        }), showClear ? _react.default.createElement(_dismissIcon.default, {
          onClick: _this2.onClear,
          ariaLabel: "Clear",
          tiny: true
        }) : null);
      });
    }
  }]);

  return Search;
}(_react.default.Component);

var SearchInput = function SearchInput(_ref) {
  var id = _ref.id,
      name = _ref.name,
      placeholder = _ref.placeholder,
      value = _ref.value,
      disabled = _ref.disabled,
      autoFocus = _ref.autoFocus,
      autoComplete = _ref.autoComplete,
      onChange = _ref.onChange,
      tabIndex = _ref.tabIndex,
      onKeyUp = _ref.onKeyUp;

  var changeHandler = function changeHandler(e) {
    return onChange(e.target.value);
  };

  return _react.default.createElement(_textInput.default, {
    type: _textInput.default.TYPE_SEARCH,
    id: id,
    name: name,
    placeholder: placeholder,
    value: value,
    disabled: disabled,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    onChange: changeHandler,
    tabIndex: tabIndex,
    onKeyUp: onKeyUp
  });
};

var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
Search.propTypes = {
  id: _propTypes.string,
  name: _propTypes.string,
  onSearch: _propTypes.func,
  placeholder: _propTypes.string,
  triggerDelay: _propTypes.number,
  disabled: _propTypes.bool,
  autoFocus: _propTypes.bool,

  /** {bool} If not used, the element will infer the autocomplete status from the browser configuration (by default is on) */
  autoComplete: _propTypes.bool,
  debounceFn: _propTypes.func,
  value: _propTypes.string,
  tabIndex: _propTypes.string,
  small: exclusiveSizes,
  large: exclusiveSizes,
  onKeyUp: _propTypes.func
};
var _default = Search;
exports.default = _default;
Search.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "defaultProps",
    "docblock": null,
    "modifiers": ["static", "get"],
    "params": [],
    "returns": null
  }, {
    "name": "onClear",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Search",
  "props": {
    "onSearch": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "triggerDelay": {
      "defaultValue": {
        "value": "300",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "debounceFn": {
      "defaultValue": {
        "value": "debounce",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "autoFocus": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "autoComplete": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "{bool} If not used, the element will infer the autocomplete status from the browser configuration (by default is on)"
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": ""
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": ""
    },
    "onKeyUp": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};